import React from 'react';
import { PlayIcon, ClipboardDocumentListIcon } from '@heroicons/react/24/outline';

interface PlayTypeStepProps {
  onSelectType: (type: 'live' | 'record') => void;
}

const PlayTypeStep: React.FC<PlayTypeStepProps> = ({ onSelectType }) => {
  return (
    <div className="flex flex-col gap-4 h-full justify-center">
      <button
        data-track="wizard_type_live"
        type="button"
        onClick={() => onSelectType('live')}
        className="flex flex-col items-center text-center gap-3 p-5 rounded-xl border border-edge
                   bg-gradient-to-br from-primary-50 to-amber-50 dark:from-primary-900/20 dark:to-amber-900/10
                   hover:border-primary-400
                   transition-all duration-150
                   active:scale-[0.98] motion-reduce:active:scale-100
                   min-h-[140px] w-full"
      >
        <div className="shrink-0 w-16 h-16 rounded-full bg-primary-100 dark:bg-primary-900/30
                        flex items-center justify-center">
          <PlayIcon className="h-8 w-8 text-primary-500" />
        </div>
        <div className="min-w-0">
          <h3 className="text-lg font-serif font-semibold text-heading">Start a Live Game</h3>
          <p className="text-sm text-muted mt-0.5">Timer, live scoring, real-time</p>
        </div>
      </button>

      <button
        data-track="wizard_type_record"
        type="button"
        onClick={() => onSelectType('record')}
        className="flex flex-col items-center text-center gap-3 p-5 rounded-xl border border-edge
                   bg-gradient-to-br from-accent-50 to-indigo-50 dark:from-accent-900/20 dark:to-indigo-900/10
                   hover:border-primary-400
                   transition-all duration-150
                   active:scale-[0.98] motion-reduce:active:scale-100
                   min-h-[140px] w-full"
      >
        <div className="shrink-0 w-16 h-16 rounded-full bg-accent-100 dark:bg-accent-900/30
                        flex items-center justify-center">
          <ClipboardDocumentListIcon className="h-8 w-8 text-accent-500" />
        </div>
        <div className="min-w-0">
          <h3 className="text-lg font-serif font-semibold text-heading">Track Results</h3>
          <p className="text-sm text-muted mt-0.5">Final results, rankings, photos</p>
        </div>
      </button>
    </div>
  );
};

export default PlayTypeStep;
